module.exports = __webpack_public_path__ + "img/login-v2.83fdfc2f.png";